const WINDOW_WIDTH = window.innerWidth;

export default {
  windowWidth: WINDOW_WIDTH,
};
